import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AdmissionsCommitmentsService } from '../admissions-commitments.service';
import { AdmissionsCommitmentsViewPart } from './commitments/commitments-view.part';
@Component({
	selector: 'admissions-commitments-views-part',
	standalone: true,
	imports: [
		AdmissionsCommitmentsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './commitments-views.part.html',
})
export class AdmissionsCommitmentsViewsPart implements OnInit {
	public service = inject(AdmissionsCommitmentsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}